import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { saveVentricularAssistDevice } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IQuickActionsState } from '../store/quickActions.types'

export function* setVentricularAssistDeviceTimelineRow() {
  try {
    const quickActionsObject: IQuickActionsState = yield select(getQuickActionsSelector)
    const { addVentricularAssistDeviceToTimeline } = quickActionsObject
    if (addVentricularAssistDeviceToTimeline) {
      yield put(saveVentricularAssistDevice())
    }
  } catch (e) {
    yield put(throwPcrException(`setVentricularAssistDeviceTimelineRow() error: ${e}`))
  }
}

export function* setVentricularAssistDeviceTimelineRowSaga() {
  yield takeLatest(
    [QuickActionsConstants.SET_ADD_VENTRICULAR_ASSIST_DEVICE_TO_TIMELINE],
    setVentricularAssistDeviceTimelineRow
  )
}
